import React, { useEffect, useRef, useState } from "react";
import styles from "./mobilesignup2style.module.css";
import InnerHeader from "../etc/innerheader";
import ChoiceValue from "./components/choicevalue";
import GetPhoneNumber from "./components/getphonenumber";
import GetCertNumber from "./components/getcertnumber";
import GetPassword from "./components/getpassword";
import SignupFinish from "./components/signupfinish";
import GetName from "./components/getname";
import GetRegistCode from "./components/getregistcode";
import { postFetch } from "../../fetch/fetch";
import { IonToast } from "@ionic/react";
import GetStudentPhoneNumber from "./components/getstudentphonenumber";

const MobileFindPassword: React.FC<any> = (props) => {

    const [page, setPage] = useState(2);
    const headerRef = useRef<HTMLDivElement>(null);

    const [value, setValue] = useState("");

    const [phoneNumber, setPhoneNumber] = useState("010");
    const [certNumber, setCertNumber] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [studentPhoneNumber, setStudentPhoneNumber] = useState("");
    const [hasDeactivatedAccount, setHasDeactivatedAccount] = useState(false);

    const [bodyHeight, setBodyHeight] = useState(0);
    const [totalBodyHeight, setTotalBodyHeight] = useState(0);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const [isPc, setIsPc] = useState(false);

    useEffect(() => {
        if (props.location && props.location.state && props.location.state.pc) {
            setIsPc(true);
        }
    }, [props.location]);

    useEffect(() => {

        if (!headerRef || !headerRef.current) return;


        const caculateBodyHeight = () => {

            if (!headerRef || !headerRef.current) return;

            const totalHeight = window.innerHeight;
            const headerHeight = headerRef.current.offsetHeight;

            setTotalBodyHeight(totalHeight);

            const lastHeight = totalHeight - headerHeight;
            setBodyHeight(lastHeight);
        }

        const calculateBodyHeightAfterDelay = () => {
            setTimeout(() => {
                caculateBodyHeight();
            }, 50);
        }

        calculateBodyHeightAfterDelay();

        window.addEventListener("resize", calculateBodyHeightAfterDelay);

        return () => window.removeEventListener("resize", calculateBodyHeightAfterDelay);

    }, [headerRef]);






    return (
        <div style={{
            maxWidth: isPc ? "500px" : "none",
            margin: isPc ? "0 auto" : "none",
        }}>
            {
                page !== 10
                    ?
                    <InnerHeader
                        headerRef={headerRef}
                        title="비밀번호 찾기"
                    />
                    :
                    ""
            }




            {
                page === 2
                    ?
                    <GetPhoneNumber setPhoneNumber={setPhoneNumber} phoneNumber={phoneNumber} bodyHeight={bodyHeight} setPage={setPage} value={value} pc={isPc}
                    type="findpassword"
                    />
                    :
                    ""
            }

            {
                page === 3
                    ?
                    <GetCertNumber 
                    type="findpassword"
                    setCertNumber={setCertNumber} certNumber={certNumber} bodyHeight={bodyHeight} setPage={setPage} phoneNumber={phoneNumber} setHasDeactivatedAccount={setHasDeactivatedAccount} setName={setName}
                    pc={isPc}
                    />
                    :
                    ""
            }

            {
                page === 4
                    ?
                    <GetPassword
                        type ="findpassword"
                    password={password} setPassword={setPassword} passwordConfirm={passwordConfirm} setPasswordConfirm={setPasswordConfirm} bodyHeight={bodyHeight} setPage={setPage} hasDeactivatedAccount={hasDeactivatedAccount}
                        phoneNumber={phoneNumber}
                        certNumber={certNumber} pc={isPc}
                    />
                    :
                    ""
            }

            {
                page === 10
                    ?
                    <SignupFinish name={name} totalBodyHeight={totalBodyHeight}
                        password={password} phoneNumber={phoneNumber}
                        history={props.history} pc={isPc}
                        type="findpassword"
                    />
                    :
                    ""
            }

            <IonToast
                isOpen={showToast}
                onDidDismiss={() => { setShowToast(false); setToastMessage(""); }}
                message={toastMessage}
                duration={1500}
                position="top"
                color="danger"
            />

        </div>
    )
}

export default MobileFindPassword;